export interface PresetRecipients {
    isEmpty: boolean;
    visible: string[];
    hiddenCount: number;
    full: string;
}

const MAX_VISIBLE_RECIPIENTS = 3;

export const formatPresetRecipients = (emails: string[] = []): PresetRecipients => {
    const full = emails.join(', ');
    if (emails.length === 0) {
        return { isEmpty: true, visible: [], hiddenCount: 0, full };
    }
    if (emails.length <= MAX_VISIBLE_RECIPIENTS) {
        return { isEmpty: false, visible: emails, hiddenCount: 0, full };
    }
    return { isEmpty: false, visible: emails.slice(0, 2), hiddenCount: emails.length - 2, full };
};
